/** WizardStepAppearance — krok 5/6 kreatora widgetu: nazwa, opis, ikona, aktywność. */

import { useTranslation } from 'react-i18next';

import { Checkbox } from '@/components/Checkbox';
import { Input } from '@/components/Input';
import { IconPicker } from '@/components/modules/IconPicker';
import { Textarea } from '@/components/Textarea';

import type { WidgetWizardDraft } from './WidgetCreatorWizard';

const LABEL_CLASS = 'block text-sm font-medium text-text-secondary';

export interface WizardStepAppearanceProps {
  draft: WidgetWizardDraft;
  patch: (p: Partial<WidgetWizardDraft>) => void;
}

export function WizardStepAppearance({ draft, patch }: WizardStepAppearanceProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <Input
        label={t('tenant.widgets.wizard.appearance.nameLabel')}
        required
        value={draft.name}
        onChange={(e) => patch({ name: e.target.value })}
        placeholder={t('tenant.widgets.wizard.appearance.namePlaceholder')}
        data-testid="widget-wizard-name"
      />

      <Textarea
        label={t('tenant.widgets.wizard.appearance.descriptionLabel')}
        rows={2}
        value={draft.description}
        onChange={(e) => patch({ description: e.target.value })}
        placeholder={t('tenant.widgets.wizard.appearance.descriptionPlaceholder')}
        data-testid="widget-wizard-description"
      />

      <div className="space-y-1">
        <span className={LABEL_CLASS}>{t('tenant.widgets.wizard.appearance.iconLabel')}</span>
        <IconPicker value={draft.icon} onChange={(name) => patch({ icon: name })} />
      </div>

      <Checkbox
        label={t('tenant.widgets.wizard.appearance.isActiveLabel')}
        checked={draft.isActive}
        onChange={(e) => patch({ isActive: e.target.checked })}
        data-testid="widget-wizard-is-active"
      />
    </div>
  );
}
